<div class="custom-select-container">
  <button
    type="button"
    class="flex !w-[28px] !h-[28px] ml-[170px] rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
    aria-expanded="false"
    (click)="toggleDropdown()"
  >
    <img
      [src]="selectedCountry ? selectedCountry?.flag : defaultCountry?.flag"
      [alt]="
        selectedCountry
          ? selectedCountry?.name + ' flag'
          : defaultCountry?.name + ' flag'
      "
      class="w-[50px] h-[30px] rounded-full"
    />
  </button>

  <div
    *ngIf="dropdownOpen"
    class="dropdown !w-[285px] mt-2 "
  >
    <div class="sticky top-0 z-50 !p-0 flex !rounded-[6.12px]">
      <input
        type="text"
        placeholder="Search "
        [(ngModel)]="searchTerm"
        (input)="filterCountries()"
        class="search-input placeholder-[#868E96]"
      />
      <img
        class="absolute right-[10px] mt-[20px] transform -translate-y-[50%] w-[1.4rem] h-[1.2rem] rounded-full"
        src="assets/icons/search.svg"
        alt="message icon"
      />
    </div>

    <!-- List of countries -->
    <ul class="max-h-[330px] overflow-y-auto text-[#000000] bg-white">
      <li
        *ngFor="let country of filteredCountries"
        (click)="onCountrySelect(country)"
        class="bg-[#FFFFFF] border-b border-t"
        [ngClass]="{ 
          'border-t-2 border-t-orange-500 bg-[#fae8e1] text-[#000000]': selectedCountry?.name === country?.name 
        }"
      
      >
        <img
          [src]="country?.flag"
          alt="{{ country?.name }} Flag"
          width="24"
          height="16"
          class="rounded-full w-[27px] h-[27px]"
        />
        {{ country?.name }}
      </li>
    </ul>
  </div>
</div>
